import { FileTextOutlined } from '@ant-design/icons';

import CommerceNoticePage from '../pages/CommerceNoticePage';

import { SiteMap } from './index';

export const commerceNoticeRoutes: SiteMap = {
  'commerce-notice': {
    title: '공지사항',
    page: CommerceNoticePage,
    icon: <FileTextOutlined />,
    key: '/commerce-notice/list',
    role: ['admin'],
  },
};
